import type { Project } from '../api/types'

type SiteFields = Pick<Project, 'siteAddress' | 'sitePostalCode' | 'siteCity'>

/**
 * Sagens eget arbejdssted på én linje: "Industrivej 12, 8000 Aarhus C".
 *
 * Null, når arbejdet foregår hos kunden (beslutning 044). Så er der ingen adresse,
 * der skiller sagen fra kundens andre sager, og kundens adresse står i forvejen på
 * kundekortet.
 */
export function workSiteLine(project: SiteFields): string | null {
  if (!project.siteAddress) return null

  const town = [project.sitePostalCode, project.siteCity].filter(Boolean).join(' ')
  return [project.siteAddress, town].filter(Boolean).join(', ')
}

/**
 * Sagen, som den står i en rulleliste: "Tavleudskiftning (TC EL) - Industrivej 12 · ordre 1042".
 *
 * En `<option>` kan ikke vise fed skrift, så adressen står med i selve teksten -
 * ellers kan man ikke vælge mellem ti sager hos samme kunde (beslutning 077).
 */
export function projectOptionLabel(
  project: Pick<Project, 'name' | 'customer' | 'orderNumber'> & SiteFields
): string {
  const site = workSiteLine(project)

  return (
    project.name +
    (project.customer ? ` (${project.customer})` : '') +
    (site ? ` - ${site}` : '') +
    (project.orderNumber ? ` · ordre ${project.orderNumber}` : '')
  )
}
